var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"respondlink"},[_c('div',[_c('van-icon',{attrs:{"name":"passed"}}),_c('p',[_vm._v("提交成功")]),_c('img',{attrs:{"src":require("../../../assets/images/humanResting/totalnum@2x.png"),"alt":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }